interface VisitorCompanySource {
	company?: string;
	name?: string;
	variables?: Array<{ name: string; title: string; value: string }>;
}

export function visitorCompanyLabel(visitor: VisitorCompanySource): string | undefined {
	const namedVariable = visitor.variables?.find(
		(variable) =>
			variable.name.trim().toLowerCase() === 'company' ||
			variable.title.trim().toLowerCase() === 'company',
	)?.value;
	const candidates = [namedVariable, visitor.company]
		.map((value) => value?.trim())
		.filter((value): value is string => Boolean(value));
	const normalisedName = visitor.name?.trim().toLowerCase();
	return candidates.find((company) => company.toLowerCase() !== normalisedName);
}
